import { frontendURL } from '../../../helper/URLHelper';

const MetricaAgents = () => import('./MetricaAgents.vue');
const MetricaAgentDetail = () => import('./MetricaAgentDetail.vue');
const MetricaReports = () => import('./MetricaReports.vue');
const MetricaScripts = () => import('./MetricaScripts.vue');
const MetricaPromptExamples = () => import('./MetricaPromptExamples.vue');
const MetricaCrm = () => import('./MetricaCrm.vue');
const MetricaAiAgents = () => import('./MetricaAiAgents.vue');
const MetricaAiSettings = () => import('./MetricaAiSettings.vue');
const MetricaResources = () => import('./MetricaResources.vue');
const MetricaBilling = () => import('./MetricaBilling.vue');
const MetricaWhatsappTemplates = () => import('./MetricaWhatsappTemplates.vue');
const MetricaWhatsappCampaigns = () => import('./MetricaWhatsappCampaigns.vue');
const MetricaWhatsappOfficialCampaigns = () =>
  import('./MetricaWhatsappOfficialCampaigns.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/metrica/agents'),
    name: 'metrica_agents',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: MetricaAgents,
  },
  {
    path: frontendURL('accounts/:accountId/metrica/agents/:userId'),
    name: 'metrica_agent_detail',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: MetricaAgentDetail,
  },
  {
    path: frontendURL('accounts/:accountId/metrica/reports'),
    name: 'metrica_reports',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: MetricaReports,
  },
  {
    path: frontendURL('accounts/:accountId/metrica/scripts'),
    name: 'metrica_scripts',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: MetricaScripts,
  },
  {
    path: frontendURL('accounts/:accountId/metrica/prompt-examples'),
    name: 'metrica_prompt_examples',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: MetricaPromptExamples,
  },
  {
    path: frontendURL('accounts/:accountId/metrica/crm'),
    name: 'metrica_crm',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: MetricaCrm,
  },
  // CRM sub-views (kanban tabs) addressable as routes so they can be expandable
  // sidebar items. All render MetricaCrm; the active tab is derived from the name.
  {
    path: frontendURL('accounts/:accountId/metrica/crm/tasks'),
    name: 'metrica_crm_tasks',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: MetricaCrm,
  },
  {
    path: frontendURL('accounts/:accountId/metrica/crm/reports'),
    name: 'metrica_crm_reports',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: MetricaCrm,
  },
  // "Agentes" opens to agent+admin (each agent manages their own AI service
  // agents, tagged with a "criado por" attribution badge); "Regras de
  // Ouro"/"Histórico" stay admin-only — global policy and account-wide audit,
  // same split now mirrored on "+ Recursos" below.
  {
    path: frontendURL('accounts/:accountId/metrica/ai-agents'),
    name: 'metrica_ai_agents',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: MetricaAiAgents,
  },
  // AI Team sub-views (tabs) as routes, for the expandable sidebar item.
  {
    path: frontendURL('accounts/:accountId/metrica/ai-agents/rules'),
    name: 'metrica_ai_agents_rules',
    meta: {
      permissions: ['administrator'],
    },
    component: MetricaAiAgents,
  },
  {
    path: frontendURL('accounts/:accountId/metrica/ai-agents/history'),
    name: 'metrica_ai_agents_history',
    meta: {
      permissions: ['administrator'],
    },
    component: MetricaAiAgents,
  },
  {
    path: frontendURL('accounts/:accountId/metrica/ai-agents/knowledge'),
    name: 'metrica_ai_agents_knowledge',
    meta: {
      permissions: ['administrator'],
    },
    component: MetricaAiAgents,
  },
  // Configuração de IA — cada conta conecta sua própria chave (OpenRouter/
  // OpenAI/Google); admin-only, uma única credencial por conta (não pessoal,
  // ao contrário de "+ Recursos" > Conexões).
  {
    path: frontendURL('accounts/:accountId/metrica/ai-settings'),
    name: 'metrica_ai_settings',
    meta: {
      permissions: ['administrator'],
    },
    component: MetricaAiSettings,
  },
  // "+ Recursos": Conexões is personal (every agent connects their own
  // credentials); Agentes now mirrors Equipe de IA (agent+admin, "criado por"
  // badge); Histórico stays admin-only (account-wide audit).
  {
    path: frontendURL('accounts/:accountId/metrica/resources'),
    name: 'metrica_resource_connections',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: MetricaResources,
  },
  {
    path: frontendURL('accounts/:accountId/metrica/resources/agents'),
    name: 'metrica_resource_agents',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: MetricaResources,
  },
  {
    path: frontendURL('accounts/:accountId/metrica/resources/history'),
    name: 'metrica_resource_agents_history',
    meta: {
      permissions: ['administrator'],
    },
    component: MetricaResources,
  },
  // Vertical hotelaria: config de propriedade (Bukly/Omnibees) por CONTA, não
  // por usuário — admin-only, ao contrário da aba Conexões acima. Ver memória:
  // metrica-hotel.
  {
    path: frontendURL('accounts/:accountId/metrica/resources/properties'),
    name: 'metrica_hotel_properties',
    meta: {
      permissions: ['administrator'],
    },
    component: MetricaResources,
  },
  // Vertical turismo receptivo: config de loja Paytour (domínio) por CONTA — os
  // passeios são descobertos automaticamente, admin-only igual Propriedades
  // acima. Ver memória: metrica-resources.
  {
    path: frontendURL('accounts/:accountId/metrica/resources/paytour'),
    name: 'metrica_paytour_stores',
    meta: {
      permissions: ['administrator'],
    },
    component: MetricaResources,
  },
  {
    path: frontendURL('accounts/:accountId/metrica/billing'),
    name: 'metrica_billing',
    meta: {
      permissions: ['administrator'],
    },
    component: MetricaBilling,
  },
  // Campanhas de WhatsApp via API não-oficial (WAHA) — admin-only, mesma
  // política de acesso do backend (ensure_admin nos 2 controllers).
  {
    path: frontendURL('accounts/:accountId/metrica/whatsapp-templates'),
    name: 'metrica_whatsapp_templates',
    meta: {
      permissions: ['administrator'],
    },
    component: MetricaWhatsappTemplates,
  },
  {
    path: frontendURL('accounts/:accountId/metrica/whatsapp-campaigns'),
    name: 'metrica_whatsapp_campaigns',
    meta: {
      permissions: ['administrator'],
    },
    component: MetricaWhatsappCampaigns,
  },
  // Campanhas de WhatsApp via API Oficial (parceiro Chakra/Cloud/360dialog) —
  // envia templates HSM já aprovados pela Meta. Admin-only, mesmo endpoint
  // backend do caminho não-oficial acima, distinguido por Campaign#kind.
  {
    path: frontendURL(
      'accounts/:accountId/metrica/whatsapp-official-campaigns'
    ),
    name: 'metrica_whatsapp_official_campaigns',
    meta: {
      permissions: ['administrator'],
    },
    component: MetricaWhatsappOfficialCampaigns,
  },
];
